import axios from "axios";
import React, {Component} from "react";
import ShoolfeeForm from "./ShoolfeeForm";
import FeatherIcon from 'feather-icons-react';
import Listprint from "../../Listprint";
import ShoolfeeInvoice from "./ShoolfeeInvoice";
import ShoolfeeInvoiceList from "./ShoolfeeInvoiceList";
import ShoolfeeFormtransport from "./ShoolfeeFormtransport";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

class   Schoolfee_ extends Component{

    state = {
        isModal : false,
        isModalTransport : false,
        loading : true,
        formData : null,
        isModalInvoice : false,
        printInvoice : false,
        classe : null,
        formDataInvoice : null,
        input : [],
        schoolfees : [],
        schoolfee : null,
        sections : [],
        columns : [
            {
                label: 'Fact',
                field: 'invoice',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Eleve',
                field: 'student',
                sort: 'asc',
                width: 200
            },
            {
                label: 'Paye par',
                field: 'responsible',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Montant',
                field: 'mount',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Trimestre',
                field: 'month',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Date',
                field: 'created_at',
                sort: 'asc',
                width: 120
            },
            {
                label: 'Obs',
                field: 'action',
                sort: 'asc',
                width: 120
            }
        ]
    }
    
    // componentDidMount(){
        // this.getSchoolfeecategory()
        // this.getSections();
    // }

    async getSchoolfees(){
        this.setState({ loading : false })
        var schoolfees = await axios.get(`/students/schoolfee/${ this.props.id }/${ this.props.schoolfeecategory }`);
        if(schoolfees.status === 200)
        {
            this.setState({ schoolfees : schoolfees.data, loading : true}) 
        }
    }
    
    showModal = (schoolfee = null, classe = null) => {
        this.setState({
            isModal : !this.state.isModal,
            formData : schoolfee,
            classe : classe
        })
        this.getSchoolfees()
    }

    showModalTransport = (schoolfee = null) => {
        this.setState({
            isModalTransport : !this.state.isModalTransport,
            formData : schoolfee,
        })
        if(schoolfee || schoolfee == 1)
            this.getSchoolfees()
    }

    showModalInvoice = (schoolfee = null) => {
        this.setState({
            isModalInvoice : !this.state.isModalInvoice,
            formDataInvoice : schoolfee,
        })
    }

    async getSchoolfee(id){
        
    }

     handleInput = (e) => {

        var data = [];
        var input = this.state.input;
        this.setState({
            input : []
        })
        var schoolfee =  e.target.value;
        var count = input.some(item => schoolfee=== item)
        if(count)
        {
            data = input.filter(item => item != schoolfee);
        }
        else{
            data = input;
            data.push(schoolfee)
        }
        
        this.setState({
            input : data
        })
    }

    printInvoice = () => {
        this.setState({
            printInvoice : !this.state.printInvoice
        })
    }

    delete = (schoolfee) =>{
        axios.delete("schoolfees/"+schoolfee).then((response) => {
            this.getSchoolfees()
            toast(response?.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
        }).catch((error)=>{
            toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
        })
    }

    handleCheck(val) {
        var permissions = localStorage.getItem("permissions") ? JSON.parse(localStorage.getItem("permissions")) : [];
         return  permissions.some(item => val === item.permission);
     }

    render(){
        var sections =  "", rows= [];

        this.state.schoolfees?.map((student) => {
            var last_name = student.user ? student.user.last_name ? student.user.last_name : "" : "";
            var first_name = student.user ? student.user.first_name ? student.user.first_name : "" : "";
            var family_name = student.user ? student.user.family_name ? student.user.family_name : "" : "";
            student.schoolfees?.filter(va => va.operation != "Supprimer")?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))?.map((schoolfee)=>{
                rows.push(
                    {
                        invoice : <span><a href={'/students/'+student.id}  className="text-decoration-none text-primary">{schoolfee.invoice}</a>  <input type={"checkbox"} onChange={this.handleInput}  value={ schoolfee.id } className="rounded rounded table_action" /> </span>,
                        student :   last_name +" "+ family_name +" "+ first_name,
                        responsible : schoolfee.user && (schoolfee.user.last_name + " " +(schoolfee.user.first_name || "")),
                        mount :  (schoolfee.pay_mount || 0)?.toLocaleString() + "" +  schoolfee.sectionschoolfeecategory.currency ,
                        month :  schoolfee.trimesectschool ? (schoolfee.trimesectschool?.trimester?.short_trimester || schoolfee.month?.month) : "",
                        created_at : new Date(schoolfee.createdAt)?.toLocaleDateString("en-GB"),
                        action : <span className="table_action">
                            <button onClick={ () => this.showModalInvoice(schoolfee)} className="btn btn-outline-primary rounded-3 btn-sm mx-1" title="facture de ce enregistrement"><FeatherIcon icon="file" size={16}></FeatherIcon> </button>
                            {
                                this.handleCheck("Supprimer paiement") == true && (
                                    <button onClick={ () => this.delete(schoolfee.id)} className="btn btn-outline-danger rounded-3 btn-sm mx-1" title="supprimer definitivement cet enregistrement"><FeatherIcon icon="delete" size={16}></FeatherIcon> </button>
                                )
                            }
                        </span>,
                    }
                )
            })
        })

        sections =
            <div className="schoolfee-class-panel" >
                <div className="schoolfee-class-panel__header">
                    <button className="schoolfee-class-panel__title" onClick={() => this.getSchoolfees()}>
                        <FeatherIcon icon="refresh-cw" size={15}></FeatherIcon>
                        <span>{ this.props.name }</span>
                    </button>
                    <div className="schoolfee-class-panel__actions">
                        {
                            // this.handleCheck("Ajouter paiement") == true && (
                            //     <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => this.props.trans ? this.showModalTransport() : this.showModal(null, this.props.id)}><FeatherIcon icon="plus" size={16}></FeatherIcon> Paiement</button>
                            // )
                            this.handleCheck("Ajouter paiement") == true && (
                                <Link to="/formschoolfee" className="btn btn-sm btn-outline-primary"><FeatherIcon icon="plus" size={16}></FeatherIcon> Paiement</Link>
                            )
                        }
                    </div>
                </div>

                <div className="schoolfee-class-panel__body">
                    {
                        rows.length > 0 ? (
                            <Listprint columns={this.state.columns} rows={rows} title={"Eleves de " + this.props?.name}/>
                        ) : (
                            <div className="schoolfee-class-empty">
                                <FeatherIcon icon="mouse-pointer" size={16} />
                                <span>Cliquez sur la classe pour charger les paiements.</span>
                            </div>
                        )
                    }

                    {
                        this.state.input.length > 0 && (
                            <div className="schoolfee-class-panel__selection">
                                <button className="btn btn-primary btn-sm" onClick={() => this.printInvoice() }>Imprimer la selection</button>
                            </div>
                        )
                    }
                </div>
            </div>

        return(
            <div>
                {
                    this.state.loading ? sections : <div className="schoolfee-class-loading"><FeatherIcon className="user-search-spin" icon="loader" /> Chargement...</div>
                }
                {
                    this.state.isModal && (
                        <ShoolfeeForm 
                            isModal={this.state.isModal} 
                            formData={this.state.formData}
                            classe={this.state.classe}
                            schoolfeecategory={ this.props.schoolfeecategory_ ? this.props.schoolfeecategory_ : null}
                            showModal={this.showModal}
                        />
                    )
                }
                {
                    this.state.isModalTransport && (
                        <ShoolfeeFormtransport 
                            isModal={this.state.isModalTransport} 
                            formData={this.state.formData}
                            schoolfeecategory={ this.props.schoolfeecategory_ ? this.props.schoolfeecategory_ : null}
                            showModal={this.showModalTransport}
                        />
                    )
                }
                {
                    this.state.formDataInvoice &&  (this.state.formDataInvoice.id && (
                        <ShoolfeeInvoice
                            isModal={this.state.isModalInvoice} 
                            formData={this.state.formDataInvoice.id}
                            schoolfeecategory={ this.props.schoolfeecategory_ ? this.props.schoolfeecategory_ : null}
                            showModal={this.showModalInvoice}
                        />
                    ))
                }
                {
                    this.state.input.length > 0 && (
                        <ShoolfeeInvoiceList
                            isModal={this.state.printInvoice} 
                            formData={this.state.input}
                            showModal={this.printInvoice}
                        />
                    )
                }
            </div>
        )
    }
}
export default Schoolfee_;
